export let chatScrollHandler = () => {
  const questionsContainer = $('.questions-container');
  if (questionsContainer.length) {
    const submitButton = $('.chat-scroll');
    submitButton.on('click', chatScroll)
  }
};

export let scrollOnQuestionExpand = () => {
  const expandQuestionBtn = $('.question-expand');
  if (expandQuestionBtn.length) {
    expandQuestionBtn.on('click', function() {
      if ($(this).attr('aria-expanded') === 'false') {
        let questionId = $(this).data('question-id');
        $('#collapse' + questionId).on('shown.bs.collapse', chatScroll);
      }
    })
  }
};

export let chatScroll = () => {
  let msgContainer = $('.messages-container');
  msgContainer.stop().animate({
    scrollTop: msgContainer[0].scrollHeight
  });
};
